import { useTranslation } from "react-i18next";
import type { RouteSourceBadgeProps } from "./types";

export const RouteSourceBadge = ({ creationSource }: RouteSourceBadgeProps) => {
  const { t } = useTranslation();

  const isManual = creationSource === "manual";

  const label = isManual
    ? t("smartSurveyor.routeInspector.sourceUserDrawn")
    : t("smartSurveyor.routeInspector.sourceAiDetected");

  const colorClasses = isManual
    ? "bg-green-100 text-green-700 border-green-200"
    : "bg-blue-100 text-blue-700 border-blue-200";

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full border text-xs font-medium ${colorClasses}`}
    >
      {label}
    </span>
  );
};
